import { defineComponent } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import EventBus from '../event-bus.js';
import utils from '../../Shared/utils.jsx';

export default defineComponent({
    name: 'user-action-listener',
    mixins: [BaseComponent],
    data: function () {
        return {
            messages: {}
        }
    },
    props: {},
    computed: {
    },
    created() {
        for (let m of this.controlData.Messages) {
            this.messages[m.MessageName] = {
                actions: m.Actions
            };
        }

        EventBus.$on(`Action-InvokeUserAction`, this.invokeUserAction);
        this.$on(`Action-InvokeUserAction`, this.invokeUserAction);
        if (this.controlData.Name)
            EventBus.$on(`Action-InvokeUserAction:${this.controlData.Name}`, this.invokeUserAction);
    },
    //Mounted Replaced with preRenderComplete
    unmounted() {
        EventBus.$off(`Action-InvokeUserAction`, this.invokeUserAction);
        this.$off(`Action-InvokeUserAction`, this.invokeUserAction);
        if (this.controlData.Name)
            EventBus.$off(`Action-InvokeUserAction:${this.controlData.Name}`, this.invokeUserAction);
    },
    methods: {
        async invokeUserAction(action) {
            let message;
            if (action.messagename)
                message = utils.evaluate(action.messagename, action.context);

            let inputdata;
            if (action.inputdata)
                inputdata = utils.evaluateObject(action.inputdata, action.context);

            if (this.messages[message] && this.messages[message].actions) {
                //for (let a of this.messages[message].actions) {
                //    const res = await utils.executeAndCompileAction(a, inputdata, this);

                //    //alert('invokeUserAction completed: ' + (res ? 'res has value' : 'res is empty'));
                //}
                await utils.executeAndCompileAllActions(this.messages[message].actions, inputdata, this);

                try {
                    await utils.success(action);
                }
                catch (e) { }
            }
        },
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
    },
    render() {
        return null;
    }
});